// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.library {
  padding: 20px;
}

.search-bar {
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  margin-bottom: 20px;
}

.book-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 20px;
}

.book-card {
  cursor: pointer;
}

.book-cover {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.book-reader {
  padding: 20px;
}

.chapter-navigation {
  margin-top: 20px;
}

button {
  padding: 10px;
  margin: 0 5px;
  border: none;
  background-color: #444;
  color: white;
  cursor: pointer;
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".library {\n  padding: 20px;\n}\n\n.search-bar {\n  padding: 10px;\n  border-radius: 5px;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.book-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 20px;\n}\n\n.book-card {\n  cursor: pointer;\n}\n\n.book-cover {\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n}\n\n.book-reader {\n  padding: 20px;\n}\n\n.chapter-navigation {\n  margin-top: 20px;\n}\n\nbutton {\n  padding: 10px;\n  margin: 0 5px;\n  border: none;\n  background-color: #444;\n  color: white;\n  cursor: pointer;\n}\n\nbutton:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
